import {css} from "@emotion/react";

import {mr, pointer} from "@pg-design/helpers-css";
import {InfoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {priceM2Format} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import type {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {useOfferListingAbroadView} from "../../hooks/use_offer_listing_abroad_view_check";
import {DesktopQuartileBar} from "./atoms/DesktopQuartileBar";
import {MobileQuartileBar} from "./atoms/MobileQuartileBar";

interface Props {
    singleRegion: ISelectedRegion;
    className?: string;
    noText?: boolean;
}

export const OfferAveragePrice = (props: Props) => {
    const {singleRegion} = props;
    const {isMobile} = useUserDevice();
    const isAbroadOffersView = useOfferListingAbroadView();

    const hasRequiredDataToRender =
        !!singleRegion.stats?.average_price_m2 &&
        !!singleRegion.stats?.active_1_percentile_price_m2 &&
        !!singleRegion.stats?.active_2_percentile_price_m2 &&
        !!singleRegion.stats?.active_3_percentile_price_m2;

    const quartileBarProps = {
        avgPrice: singleRegion.stats?.average_price_m2 as number,
        firstQuartile: singleRegion.stats?.active_1_percentile_price_m2 as number,
        secondQuartile: singleRegion.stats?.active_2_percentile_price_m2 as number,
        thirdQuartile: singleRegion.stats?.active_3_percentile_price_m2 as number
    };

    if (!hasRequiredDataToRender) {
        return null;
    }

    return (
        <div css={offerAveragePriceSection({isMobile})} className={props.className}>
            <div css={offerAveragePriceHolder}>
                {!props.noText && (
                    <Text variant="body_copy_1" css={mr(3)}>
                        Średnia cena nieruchomości w tej lokalizacji{" "}
                        <strong>
                            {singleRegion.stats?.average_price_m2 &&
                                priceM2Format(singleRegion.stats?.average_price_m2, {unit: isAbroadOffersView ? "eur" : undefined})}
                        </strong>
                    </Text>
                )}

                {isMobile && hasRequiredDataToRender ? (
                    <MobileQuartileBar {...quartileBarProps}>
                        <InfoIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
                    </MobileQuartileBar>
                ) : (
                    <DesktopQuartileBar {...quartileBarProps}>
                        <InfoIcon css={pointer} size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
                    </DesktopQuartileBar>
                )}
            </div>
        </div>
    );
};

const offerAveragePriceSection = (props: {isMobile: boolean | null}) => {
    return css`
        overflow: hidden;
        height: auto;
        max-height: ${props.isMobile ? "8rem" : "6rem"};
    `;
};

const offerAveragePriceHolder = css`
    display: flex;
    align-items: center;
    padding-top: 0.8rem;
`;
import {css} from "@emotion/react";

import {mr, pointer} from "@pg-design/helpers-css";
import {InfoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {priceM2Format} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import type {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {useOfferListingAbroadView} from "../../hooks/use_offer_listing_abroad_view_check";
import {DesktopQuartileBar} from "./atoms/DesktopQuartileBar";
import {MobileQuartileBar} from "./atoms/MobileQuartileBar";

interface Props {
    singleRegion: ISelectedRegion;
    className?: string;
    noText?: boolean;
}

export const OfferAveragePrice = (props: Props) => {
    const {singleRegion} = props;
    const {isMobile} = useUserDevice();
    const isAbroadOffersView = useOfferListingAbroadView();

    const hasRequiredDataToRender =
        !!singleRegion.stats?.average_price_m2 &&
        !!singleRegion.stats?.active_1_percentile_price_m2 &&
        !!singleRegion.stats?.active_2_percentile_price_m2 &&
        !!singleRegion.stats?.active_3_percentile_price_m2;

    const quartileBarProps = {
        avgPrice: singleRegion.stats?.average_price_m2 as number,
        firstQuartile: singleRegion.stats?.active_1_percentile_price_m2 as number,
        secondQuartile: singleRegion.stats?.active_2_percentile_price_m2 as number,
        thirdQuartile: singleRegion.stats?.active_3_percentile_price_m2 as number
    };

    if (!hasRequiredDataToRender) {
        return null;
    }

    return (
        <div css={offerAveragePriceSection({isMobile})} className={props.className}>
            <div css={offerAveragePriceHolder}>
                {!props.noText && (
                    <Text variant="body_copy_1" css={mr(3)}>
                        Średnia cena nieruchomości w tej lokalizacji{" "}
                        <strong>
                            {singleRegion.stats?.average_price_m2 &&
                                priceM2Format(singleRegion.stats?.average_price_m2, {unit: isAbroadOffersView ? "eur" : undefined})}
                        </strong>
                    </Text>
                )}

                {isMobile && hasRequiredDataToRender ? (
                    <MobileQuartileBar {...quartileBarProps}>
                        <InfoIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
                    </MobileQuartileBar>
                ) : (
                    <DesktopQuartileBar {...quartileBarProps}>
                        <InfoIcon css={pointer} size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
                    </DesktopQuartileBar>
                )}
            </div>
        </div>
    );
};

const offerAveragePriceSection = (props: {isMobile: boolean | null}) => {
    return css`
        overflow: hidden;
        height: auto;
        max-height: ${props.isMobile ? "8rem" : "6rem"};
    `;
};

const offerAveragePriceHolder = css`
    display: flex;
    align-items: center;
    padding-top: 0.8rem;
`;
